import React from "react"
import { SpinIcon } from "@atos6/icons"
import { hvcenter } from "@atos6/ui"
import { useStore } from "./containers"

type Props = {
  children: React.ReactNode
}

export function LoadingPage({ children }: Props) {
  const { isReady } = useStore()
  return isReady ? <>{children}</> : <Fallback />
}

const Fallback = () => (
  <div style={{ ...hvcenter, minHeight: 400 }}>
    <SpinIcon />
  </div>
)
